import { type BuildingBlock, NodeType } from '@nodeTypeConfig/configTypes';

export const llinkidDefaultBuildingBlocks: Array<BuildingBlock> = [
  { type: NodeType.SECTION },
  { type: NodeType.PARAGRAPH },
  { type: NodeType.IMAGE },
  { type: NodeType.VIDEO },
];
